import React, { useState, useRef, useEffect } from 'react'
import './ContactUs.css'
import { useAuth } from '../Context/AuthContext'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787'

const stripHtml = (str) => {
  if (typeof str !== 'string') return ''
  return str.replace(/<[^>]*>/g, '').replace(/[<>]/g, '').trim()
}

const ContactUs = () => {
  const formRef = useRef(null)
  const { user } = useAuth()
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [sending, setSending] = useState(false)

  useEffect(() => {
    if (user && formRef.current) {
      formRef.current.name.value = user.name || ''
      formRef.current.email.value = user.email || ''
    }
  }, [user])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    const form = formRef.current
    const name = stripHtml(form.name.value)
    const email = stripHtml(form.email.value)
    const subject = stripHtml(form.subject.value)
    const message = stripHtml(form.message.value)

    if (!name || !email || !subject || !message) {
      setError('Please fill in all fields.')
      return
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.')
      return
    }

    setSending(true)

    try {
      const res = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, subject, message }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Failed to send')
      setSent(true)
      form.reset()
    } catch {
      setError('Failed to send. Please try again later.')
    } finally {
      setSending(false)
    }
  }

  return (
    <div className='contact-page'>

      <div className='contact-hero'>
        <h1>Contact Us</h1>
        <p>We would love to hear from you. Whether you have a question about our products, want to collaborate, or just want to say hello — reach out.</p>
      </div>

      <div className='contact-grid'>

        <div className='contact-info'>

          <div className='contact-card'>
            <h3>Get in Touch</h3>
            <p><strong>Email:</strong></p>
            <a href='mailto:info@tagershoppe.com'>info@tagershoppe.com</a>
          </div>

        </div>

        {sent ? (
          <div className='contact-form' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', padding: '60px 30px' }}>
            <h2>Thank you!</h2>
            <p style={{ color: '#555', fontSize: 16, lineHeight: 1.6 }}>Your message has been sent. We will get back to you as soon as possible.</p>
          </div>
        ) : (
          <form className='contact-form' ref={formRef} onSubmit={handleSubmit}>
            <h2>Send a Message</h2>

            <label htmlFor='name'>Name</label>
            <input id='name' name='name' type='text' placeholder='Your name' required />

            <label htmlFor='email'>Email</label>
            <input id='email' name='email' type='email' placeholder='your@email.com' required />

            <label htmlFor='subject'>Subject</label>
            <input id='subject' name='subject' type='text' placeholder='What is this about?' required />

            <label htmlFor='message'>Message</label>
            <textarea id='message' name='message' placeholder='Your message...' required />

            {error && <p style={{ color: '#c00', fontSize: 14, marginBottom: 12 }}>{error}</p>}

            <button type='submit' disabled={sending}>{sending ? 'Sending...' : 'Send Message'}</button>
          </form>
        )}

      </div>

    </div>
  )
}

export default ContactUs
